import React, { Component } from 'react'

import ColoniaAutocomplete from '../ColoniaAutocomplete'
import Waypoint from 'react-waypoint'
import qs from 'qs'
import moment from 'moment-timezone'
import { TIMEZONE } from '@src/globals'

import './BookingForm.scss'

class BookingForm extends Component {
  constructor (props) {
    super(props)
    this.state = {
      coordinates: {
        latitude: undefined,
        longitude: undefined
      },
      estimatedHours: 3,
      serviceType: 'one-time',
      preferences: [],
      skills: new Set(),
      pets: "No",
      showPopup: false
    }
  }

  handleServiceTypeChange = event => {
    this.setState({
      serviceType: event.target.value
    });

  }

  handleColoniaSelect = location => {
    this.setState({
      neighborhood: location.label,
      coordinates: {
        latitude: location.location.lat,
        longitude: location.location.lng,
      }
    })
  }

  handleEstimatedHours = event => {
    this.setState({
      estimatedHours: event.target.value
    });
  }

  handlePets = event => {
    const value = event.target.value
    var preferences = []

    if (value === "Sí") {
      preferences.push('pets')
      this.setState({
        preferences: preferences,
        pets: "Si"
      });
    } else {
      this.setState({
        preferences: preferences,
        pets: "No"
      });
    }
  }

  toggleCheckbox = event => {
    const skill = event.target.value
    var { skills } = this.state

    if (skills.has(skill)) {
      skills.delete(skill);
    } else {
      skills.add(skill);
    }

    this.setState({
      skills: skills
    });
  }

  handleSearch = () => {
    const baseUrl = process.env.WILLKOMMEN_ROOT;
    const { coordinates, serviceType, skills, estimatedHours, preferences, neighborhood } = this.state;
    const format = {
      encode: false,
      arrayFormat: 'brackets'
    }

    const querystring = qs.stringify({
      neighborhood: neighborhood,
      latitude: coordinates.latitude,
      longitude: coordinates.longitude,
      serviceHours: estimatedHours,
      skills: ['cleaning', ...skills],
      serviceType: serviceType,
      preferences: preferences
    }, format)

    window.location.href = `${baseUrl}s/aliadas?${querystring}`;
  }

  showPopup() {
    this.setState({
      showPopup: true
    });
  }

  hidePopup() {
    this.setState({
      showPopup: false
    });
  }

  render () {
    const date                   = new Date()
    const datetime               = moment.tz(date, TIMEZONE)
    const day                    = datetime.day()
    const hour                   = datetime.hour()
    const saturday               = 6
    const sunday                 = 0
    const urgentServiceOutOfTime = day == saturday ?
                                     !(7 <= hour && hour < 15) :
                                   day == sunday   ?
                                     !(7 <= hour && hour < 14) :
                                     !(7 <= hour && hour < 17)


    const { coordinates } = this.state;

    const urgentServiceOutOfTimeText = `Horarios:
                                       lunes a viernes 7 am a 5 pm;
                                       sábado 7 am a 3 pm;
                                       domingo 7 am a 2 pm`

    class Popup extends React.Component {
      render() {
        return (
          <div className='popup'>
            <div className='popup_inner'>
              <h4>{this.props.text}</h4>
            </div>
          </div>
        );
      }
    }

    return (
      <div className="bookingForm">
        <div className='Home-heroText'>
          <h1>Tu hogar limpio y seguro con <span>aliada</span></h1>

          <div className='Login-separator'>
            <span className='Login-separator-line' />
          </div>

          <div className='Home-frecuency'>
            <h4>FRECUENCIA DEL SERVICIO</h4>

            <div className='Home-radioGroup'>
              <div className="radioServiceType">
                  <input id="1" type="radio" value="one-time"
                         checked={this.state.serviceType === 'one-time'}
                         onChange={this.handleServiceTypeChange}
                         autoComplete="off"
                         onClick={this.hidePopup.bind(this)} />

                  <label htmlFor="1">Una vez</label>
              </div>
              <div className="radioServiceType">
                <input id="2" type="radio" value="recurrent"
                         checked={this.state.serviceType === 'recurrent'}
                         onChange={this.handleServiceTypeChange}
                         autoComplete="off"
                         onClick={this.hidePopup.bind(this)} />
                <label htmlFor="2">Semanal</label>
              </div>
              <div className="radioServiceType">
                <input id="3" type="radio" value="urgent"
                         checked={this.state.serviceType === 'urgent'}
                         onChange={this.handleServiceTypeChange}
                         autoComplete="off"
                         onClick={this.showPopup.bind(this)} />
                <label htmlFor="3">Urgente</label>
              </div>
            </div>
            {
              this.state.showPopup && urgentServiceOutOfTime ?
              <Popup text = {urgentServiceOutOfTimeText} /> :
               null
            }
          </div>

          <div
            ref={(el) => {
              this._coloniaAutocomplete = el
            }}
            >
            <h4>DÓNDE</h4>

            <ColoniaAutocomplete
              onSelect={this.handleColoniaSelect}
              getRef={(el) => { this._geoSuggest = el }}
              onFocus={this.scrollSearchToTop}
              />
            <Waypoint
              onEnter={this.searchEntersSight}
              onLeave={this.searchLeavesSight}
              />
          </div>

          <div className="chosen-wrapper">
              <div>
                <h4>DURACIÓN</h4>

                <select id="estimatedHours" onChange={this.handleEstimatedHours} value={this.state.estimatedHours} className="chosen-select-hours" >
                  <option value="3">3 horas</option>
                  <option value="4">4 horas</option>
                  <option value="5">5 horas</option>
                  <option value="6">6 horas</option>
                  <option value="7">7 horas</option>
                  <option value="8">8 horas</option>
                </select>
              </div>

              <div>
                <h4>MASCOTAS</h4>

                <select id="Pets" onChange={this.handlePets} value={this.state.pets} className="chosen-select-pets" >
                  <option value="No" autoComplete="off">No</option>
                  <option value="Si" autoComplete="off">Si</option>
                </select>
              </div>
          </div>

          <div className="chips">
            <h4>SERVICIOS ADICIONALES</h4>
            <ul className="ks-cboxtags">
              <li>
                <input type="checkbox" id="laundry" value="laundry" onClick={this.toggleCheckbox} autoComplete="off" />
                <label htmlFor="laundry">
                  Lavado
                </label>
              </li>
              <li>
                <input type="checkbox" id="ironing" value="ironing" onClick={this.toggleCheckbox} autoComplete="off" />
                <label htmlFor="ironing">
                  Planchado
                </label>
              </li>
              <li>
                <input type="checkbox" id="cooking" value="cooking" onClick={this.toggleCheckbox} autoComplete="off" />
                <label htmlFor="cooking">
                  Cocina
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div className='submitButton'>
          <button
            className='btn btn-primary btn-block btn-lg'
            onClick={this.handleSearch}
            disabled={coordinates.latitude  == undefined ||
                      coordinates.longitude == undefined ||
                      (urgentServiceOutOfTime && this.state.serviceType =='urgent')}
            >
            BUSCAR
          </button>
        </div>
      </div>
    )
  }
}

export default BookingForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Home/components/BookingForm/BookingForm.js